import { AuthService } from '@/service/AuthService'
import TYPES from '@/config/Types'
import { DependencyContainer } from '@/config/DependencyContainer'

const authService: AuthService = DependencyContainer.getContainer().get<AuthService>(TYPES.AuthService)

const authUtils = {
    get authService (): AuthService { return authService },
}

export default authUtils
